/* Angular Stuff*/
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

/* Our Own Stuff*/
import { LangService } from 'src/app/core/services/lang.service';
import { GridService } from 'src/app/shared/services/grid.service';
import { DataLoadService } from 'src/app/shared/services/data-load.service';

@Component({
  selector: 'app-bank-list',
  templateUrl: './../../../templates/forms/modals/bank-list-component.html',
})
export class BankListComponent implements OnInit {
  @Input()
  modalShow: boolean = true;

  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  dataObj:any;

  columnDefs = [];
  colObj;
  grid: any;
  gridId: string = "BankListGrid"

  bankList:any[] = [];
  public searchString;
  constructor(private dataService: DataLoadService,
    public langService: LangService,
    public gridService:GridService) { 
      this.colObj = [
        { headerName: langService.langData.bankName, field: 'BRANCH_NAME', sortable: true, resizable: true, hide: false },
        { headerName: langService.langData.branceAddress, field: 'BRANCH_ADDR', sortable: true, resizable: true, hide: false },
        { headerName: langService.langData.bankAccNo, field: 'BANK_ACC_NO', sortable: true, resizable: true, hide: false },
      ];
    }

  ngOnInit() {  
    this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId); 
  }
  onGridReady(grid) {
    this.grid = grid;
    this.gridService.sizeColumnsToFit(grid, this.gridId);
    this.dataService.load('FG_HR_COMM_BANK').subscribe(results=>{
      this.bankList = results.body;
    })
  }
  itemClick(_item) {
    this.modalShow = false;
    this.dataObj = _item;
    this.submit.next();
  }

} 